import styled from "styled-components";

export const KTSCTICalendarWrapper = styled.div`
  flex-shrink: 0;
`;
